import { Culture, MimeType } from '@/models/enums';

import { Role } from '@/helpers/role';
import _ from 'lodash';

const getters = {
    currentCulture: state => state.language,
    activeRoute: state => state.activeRoute,
    sidemenu: state => state.sidemenu,
    authToken: state => state.authToken,
    loggedUser: state => state.loggedUser,
    userName: state => state.userName,
    userEmail: state => state.userEmail,
    userShortFullName: state => state.userShortFullName,
    userFullName: state => state.userFullName,
    userFullNameEn: state => state.userFullNameEn,
    userRoles: state => state.userRoles,
    tokenExpiration: state => state.tokenExpiration,
    isAuthenticated: state => {
        if (state && state.authToken && (new Date(state.tokenExpiration) > new Date())) {
            return true;
        }
        return false;
    },
    baseUrl: state => state.baseUrl,
    loadedLanguages: state => state.loadedLanguages,
    notificationDuration: state => state.notificationDuration,
    notificationLongDuration: state => state.notificationLongDuration,
    defaultGridRows: state => state.defaultGridRows,
    defaultGridPageSize: state => state.defaultGridPageSize,
    defaultGridPageButtonCount: state => state.defaultGridPageButtonCount,
    isInProduction: state => state.isInProduction,
    bulgariaNomId: state => state.bulgariaNomId,
    sofiaNomId: state => state.sofiaNomId,
    nipCoords: state => state.nipCoords,
    userTasks: state => state.userTasks,
    userStartedTasks: state => state.userStartedTasks,
    userOverdueTasks: state => state.userOverdueTasks,
    userCoordinations: state => state.userCoordinations,
    userOverdueCoordinations: state => state.userOverdueCoordinations,
    eventNameColumnName: state => state.eventNameColumnName,
    userId: state => state.userId,
    userClaims: state => state.userClaims,
    eventClaims: state => state.eventClaims,
    eventReadRights: state => state.eventReadRights,
    eventEditRights: state => state.eventEditRights,
    isDeveloper: state => state.isDeveloper,
    gridOptions: state => state.gridOptions,
    claims: state => state.claims,
    pageTitle: state => state.pageTitle,
    pageTitleDescription: state => state.pageTitleDescription,
    certificateStatuses: state => state.certificateStatuses,
    dateTimeFormat: state => state.dateTimeFormat,
    dateTimeLongFormat: state => state.dateTimeLongFormat,
    dateFormat: state => state.dateFormat,
    timeFormat: state => state.timeFormat,
    participationRequestNameEn: state => state.participationRequestNameEn,
    isEnVersion: state => state.language === Culture.EN,
    currentRegister: state => state.currentRegister,
    hasLoadedRegister: state => _.isEmpty(state.currentRegister) === false,
    quotaTypes: state => state.quotaTypes,
    evaluationCriteriaTypes: state => state.evaluationCriteriaTypes,
    constraintTypes: state => state.constraintTypes,
    operators: state => state.operators,
    reportingServerUrl: state => state.reportingServerUrl,
    nomDropdownSettings: state => state.nomDropdownSettings,
    userSettings: state => state.userSettings,
    appSettings: state => state.appSettings,
    personRequiredFields: state => state.personRequiredFields,
    personEditCardRequiredFields: state => state.personEditCardRequiredFields,
    participantEditCardRequiredFields: state => state.participantEditCardRequiredFields,
    tempRakingCandidateRequiredFields: state => state.tempRakingCandidateRequiredFields,
    userPolicies: state => state.userPolicies,
    dropdownHeight: state => state.dropdownHeight,
    gridShowEllipsis: state => state.gridShowEllipsis,
    showHelp: state => state.userRoles && state.userRoles.includes(Role.DevAdmin),
    dataReferencesListCount: state => state.dataReferencesListCount,
    allowParticipantsSoftDelete: state => state.allowParticipantsSoftDelete,
    allowLecturersSoftDelete: state => state.allowLecturersSoftDelete,
    appSigningSettings: state => state.appSigningSettings,
    checkSignImage: state => state.checkSignImage,
    signingFilesAcceptFilter: _ => `${MimeType.Pdf},${MimeType.Docx}`,
    signingAllowFileTypes: _ => [MimeType.Pdf, MimeType.Docx],
    fileSizeLimit: state => state.fileSizeLimit,
}

export default getters;
